<template>
  <BoardView id="ArticleTopics" :title="$t('title')">
    <FormValidation @submit="create">
      <FormTopicScaffold
        :value.sync="topicsScaffold" />
      <RowGrid>
        <Btn
          class="info"
          :isLoading="isSaving"
          type="submit">
          {{ $t('submit') }}
        </Btn>
        <Btn
          class="info light"
          :isLoading="isSaving"
          @click="copySpreadsheet">
          {{ $t('copy') }}
        </Btn>
      </RowGrid>
    </FormValidation>
  </BoardView>
</template>

<script>
import { filter, indexBy, map, mergeDeepRight, pick, pipe, prop } from 'rambda'
import BoardAdd from '@mixins/BoardAdd'
import FormTopicScaffold from './components/FormTopicScaffold'
import { actions } from '@utils'
import { convertJsonToRows } from '@store/modules/articleBlueprint'

export default {
  mixins: [
    BoardAdd('articleScaffold', {
      redirectTo: null,
      stateKey: null,
      successMessage: self => self.$t('done'),
    }),
  ],
  components: { FormTopicScaffold },
  data() {
    return {
      topicsScaffold: [],
    }
  },
  methods: {
    copySpreadsheet() {
      const spreadsheetRows = convertJsonToRows(this.topicsScaffold)

      this.$clipboard(spreadsheetRows)
    },
    async createDirect() {
      const rows = await this
        .CREATE_ARTICLE_NICHE({
          topicsScaffold: map(pick(['category', 'topic']), this.topicsScaffold),
        })

      const byTopic = indexBy(prop('topic'), this.topicsScaffold)

      this.topicsScaffold = pipe(
        filter(row => row.topic in byTopic),
        map(row => mergeDeepRight(
          byTopic[row.topic] || {},
          row,
        )),
      )(rows)
    },
    ...actions('CREATE_ARTICLE_NICHE'),
  },
}
</script>

<i18n>
{
  "en": {
    "copy": "Copy",
    "done": "Filled",
    "submit": "Fill weights",
    "title": "Article topics"
  }
}
</i18n>
